import carrierTypes from './carrierInformationTypes'

export const initialState = {
  carrier: {},
  load: false,
  error: '',
  loadUpdate: false,
  errorUpdate: false
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case carrierTypes.GET_CARRIER: {
      return {
        ...state,
        load: true,
        error: null
      }
    }

    case carrierTypes.GET_CARRIER_SUCCESS: {
      return {
        ...state,
        load: false,
        error: null,
        carrier: payload
      } }

    case carrierTypes.GET_CARRIER_FAILURE:
      return {
        ...state,
        load: false,
        error: payload
      }

    case carrierTypes.UPDATE_CARRIER: {
      return {
        ...state,
        loadUpdate: true,
        errorUpdate: null
      }
    }

    case carrierTypes.UPDATE_CARRIER_SUCCESS: {
      return {
        ...state,
        loadUpdate: false,
        errorUpdate: null
      } }

    case carrierTypes.UPDATE_CARRIER_FAILURE:
      return {
        ...state,
        loadUpdate: false,
        errorUpdate: payload
      }

    default: {
      return state
    }
  }
}
